@if (itemGroupsToImport.length > 0) {
  <div class="item-import-container">
    <mat-accordion>
      <mat-expansion-panel (opened)="importItemPanelOpenState = true" (closed)="importItemPanelOpenState = false">
        @if (importItemPanelOpenState) {
          <mat-expansion-panel-header class="panel-open">
            <mat-panel-title>Item Name</mat-panel-title>
            <mat-panel-description>Item Description</mat-panel-description>
          </mat-expansion-panel-header>
        }
        @if (!importItemPanelOpenState) {
          <mat-expansion-panel-header>
            <mat-panel-title class="panel-item-closed">Import Items</mat-panel-title>
            <mat-panel-description class="panel-item-closed">{{
              itemGroupsToImport.length + " New Items"
            }}</mat-panel-description>
          </mat-expansion-panel-header>
        }
        <ng-template matExpansionPanelContent>
          <cdk-virtual-scroll-viewport appendOnly itemSize="50" class="import-item-viewport">
            <app-unimported-item-group-tile
              [viewModel]="currentItem"
              (externalItemNumberImportEmit)="openItemImportDialog(currentItem)"
              *cdkVirtualFor="
                let currentItem of itemGroupsToImport;
                templateCacheSize: 0;
                trackBy: importItemGroupTrackBy
              "
              class="item">
            </app-unimported-item-group-tile>
          </cdk-virtual-scroll-viewport>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
}

<h1>Manage Items</h1>
<p>Edit Items or Turn Item Availability ON/OFF for this Wegmans Meals 2GO location</p>

@if (filteredItemGroupEntities) {
  <app-manage-item-filter [items]="menuItems" [pageName]="'Items'" (filteredItemsEvent)="updateFilteredItems($event)">
  </app-manage-item-filter>
}
<div class="count-container">
  <div class="med-gray-text filtered-item-count">Showing {{ numberOfFilteredItems }} result(s)</div>
</div>
<div class="table-container" role="table">
  <div class="flex-table header">
    <div class="flex-row cin small">Item #</div>
    <div class="flex-row names large">Item Name</div>
    <div class="flex-row names large">Description</div>
    <div class="flex-row small">Lead Time</div>
    <div class="flex-row small">Prep Time</div>
    <div class="flex-row medium">Pickup Dates</div>
    <div class="flex-row medium">Hand-off Restrictions</div>
    <div class="flex-row medium">Sold / Total Quantity</div>
    <div class="flex-row small">Availability</div>
    <div class="flex-row small"><!-- placeholder for edit --></div>
  </div>
  <cdk-virtual-scroll-viewport itemSize="55" class="item-viewport" appendOnly>
    <app-item-group-tile
      [viewModel]="currentItem"
      (externalItemNumberAvailabilityEmit)="openAvailabilityDialog($event)"
      (externalItemNumberEditEmit)="openItemEditDialog(currentItem)"
      (externalItemNumberStockRefreshEmit)="externalItemNumberStockRefresh(currentItem)"
      (resolveInconsistencyEmit)="openResolveInconsistencyDialog($event)"
      *cdkVirtualFor="
        let currentItem of filteredItemGroupEntities;
        templateCacheSize: 0;
        trackBy: filteredItemGroupEntityTrackBy
      ">
    </app-item-group-tile>
  </cdk-virtual-scroll-viewport>
</div>
